import React, { SyntheticEvent } from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { ChevronRight, Close } from '@withjoy/joykit/icons';

type ReEngagementPopupItemProps = {
  itemKey: string;
  title: string;
  subtitle: string;
  imageUrl: string;
  onClick: () => void;
  onRemove: () => void;
};
const ReEngagementPopupItem = ({ itemKey, title, subtitle, imageUrl, onClick, onRemove }: ReEngagementPopupItemProps) => {
  return (
    <Flex alignItems="stretch" flexDirection="row" gap={5}>
      <Flex
        alignItems="center"
        justifyContent="center"
        width={32}
        onClick={(e: SyntheticEvent) => {
          onRemove();
          e.stopPropagation();
        }}
        cursor="pointer"
        role="group"
      >
        <Close size={24} color="mono6" _groupHover={{ color: 'primary1' }} />
      </Flex>
      <Flex alignItems="center" flexDirection="row" cursor="pointer" gap={5} onClick={onClick} role="group">
        <Flex width={'56px'} backgroundColor="green1" borderRadius={2} overflow="hidden">
          <img width={'56px'} src={imageUrl} alt={itemKey} />
        </Flex>
        <Flex flexDirection="column" flex={1}>
          <TextV2 typographyVariant="button2" color="primary1">
            {title}
          </TextV2>
          <TextV2 typographyVariant="label2" color="mono4">
            {subtitle}
          </TextV2>
        </Flex>
        <Flex width={'32px'} height={'32px'} _groupHover={{ backgroundColor: 'mono13' }} borderRadius={'100%'} cursor="pointer" alignItems="center" justifyContent="center">
          <ChevronRight size={16} color="#FFFFFF" />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default ReEngagementPopupItem;
